import { Button, InputNumber, Select } from 'antd';

import { useSubscriptionServicePicker } from '../hooks/useSubscriptionServicePicker';

import type { FC } from 'react';

import './SubscriptionServicePicker.scss';

interface SubscriptionServicePickerProps {
  options: { value: number; label: string }[];
  isLoading: boolean;
  onAdd: (serviceId: number, count: number) => void;
  onCancel: () => void;
}

export const SubscriptionServicePicker: FC<SubscriptionServicePickerProps> = ({
  options,
  isLoading,
  onAdd,
  onCancel,
}) => {
  const { serviceId, count, isAddDisabled, changeService, changeCount, add } =
    useSubscriptionServicePicker({ onAdd });

  return (
    <div className="SubscriptionServicePicker">
      <label className="SubscriptionServicePicker__field SubscriptionServicePicker__field--service">
        <span className="SubscriptionServicePicker__label">Услуга</span>
        <Select<number>
          showSearch
          value={serviceId ?? undefined}
          options={options}
          loading={isLoading}
          optionFilterProp="label"
          placeholder="Выберите услугу из справочника"
          notFoundContent="Услуги не найдены"
          onChange={changeService}
          data-testid="subscription-service-select"
        />
      </label>
      <label className="SubscriptionServicePicker__field SubscriptionServicePicker__field--count">
        <span className="SubscriptionServicePicker__label">Количество</span>
        <InputNumber
          min={1}
          precision={0}
          value={count}
          onChange={changeCount}
          className="SubscriptionServicePicker__count"
          data-testid="subscription-service-count"
        />
      </label>
      <div className="SubscriptionServicePicker__actions">
        <Button onClick={onCancel}>Отмена</Button>
        <Button
          type="primary"
          disabled={isAddDisabled}
          onClick={add}
          data-testid="subscription-service-add"
        >
          Добавить
        </Button>
      </div>
    </div>
  );
};
